export interface GetCountryListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetCountryListPagingAndFilterResponseData
}

export interface GetCountryListPagingAndFilterResponseData {
    items: GetCountryListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetCountryListPagingAndFilterResponseItem {
    countryId: string
    code: string
    name: string
    isEurope: boolean
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetCountryListPagingAndFilterResponseData: GetCountryListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}